import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCoins01 = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_608_31023)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.80227 4.80178C5.34629 2.43305 7.46655 0.666687 10.0003 0.666687C12.9458 0.666687 15.3337 3.0545 15.3337 6.00002C15.3337 8.53379 13.5673 10.6541 11.1986 11.1981C10.6549 13.5667 8.53392 15.3334 6.00033 15.3334C3.05481 15.3334 0.666992 12.9455 0.666992 10C0.666992 7.46643 2.43364 5.34546 4.80227 4.80178ZM5.45404 6.03701C5.46077 6.03622 5.46748 6.03532 5.47417 6.03432C5.64635 6.01169 5.82197 6.00002 6.00033 6.00002C8.20946 6.00002 10.0003 7.79088 10.0003 10C10.0003 10.1784 9.98865 10.354 9.96603 10.5262C9.96503 10.5329 9.96413 10.5396 9.96333 10.5463C9.69693 12.497 8.02415 14 6.00033 14C3.79119 14 2.00033 12.2092 2.00033 10C2.00033 7.97619 3.50334 6.30341 5.45404 6.03701ZM11.329 9.77424C11.2138 7.00831 8.99203 4.78657 6.2261 4.67138C6.77378 3.11549 8.25719 2.00002 10.0003 2.00002C12.2095 2.00002 14.0003 3.79088 14.0003 6.00002C14.0003 7.74316 12.8849 9.22657 11.329 9.77424Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_608_31023",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgCoins01;
